import red from '@material-ui/core/colors/red';
import { makeStyles, useTheme } from '@material-ui/core/styles';

export const Theme = useTheme;

export const useStyles = makeStyles(theme => {
	return {
		wrapper: {
			padding: '0 15px'
		},
		radioButtonBox: {
			flexDirection: 'row',
			alignItems: 'center',
			width: '100%',
			marginBottom: 20,
			'& > label': {
				flexGrow: 1
			}
		},
		directDownloadAlertMessageBox: {
			color: red[500],
			fontSize: 14,
			lineHeight: 2
		},
		userConsentWrapper: {
			marginTop: 25
		}
	};
});
